export enum CampaignStatus {
	DRAFT = "DRAFT",
	RUNNING = "RUNNING",
	PAUSED = "PAUSED",
	ENDED = "ENDED",
	LOADING = "LOADING",
}
